/**
 * Signature ProduWeb du pied de page, reprise à l'identique de Lily La Boulangerie (28/10/2026) : à l'entrée dans
 * l'écran, les barres puis les lettres montent (CSS, classe .vu), le filet se trace, puis un reflet blanc traverse le
 * mot ; il repasse toutes les 6 secondes tant que la signature est visible. Rien si l'appareil demande moins
 * d'animations.
 */
document.addEventListener('DOMContentLoaded', () => {
    const a = document.querySelector('[data-pdw-sig]');
    if (!a) {
        return;
    }
    const grad = a.querySelector('#pdwsheen');
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        a.classList.add('vu', 'fixe');
        return;
    }
    let minuterie = null;
    let anim = null;
    const reflet = () => {
        if (!grad) {
            return;
        }
        const t0 = performance.now();
        const pas = (t) => {
            const k = Math.min(1, (t - t0) / 1600);
            const e = k < 0.5 ? 2 * k * k : 1 - ((-2 * k + 2) ** 2) / 2;
            const x = -80 + e * 410;
            grad.setAttribute('x1', String(x));
            grad.setAttribute('x2', String(x + 60));
            if (k < 1) {
                anim = requestAnimationFrame(pas);
            } else {
                minuterie = setTimeout(reflet, 6000);
            }
        };
        anim = requestAnimationFrame(pas);
    };
    const arret = () => {
        clearTimeout(minuterie);
        cancelAnimationFrame(anim);
    };
    new IntersectionObserver((e) => {
        const vis = e.some((x) => x.isIntersecting);
        if (vis && !a.classList.contains('vu')) {
            a.classList.add('vu');
            minuterie = setTimeout(reflet, 1700);
        } else if (vis) {
            arret();
            reflet();
        } else {
            arret();
        }
    }, {threshold: 0.4}).observe(a);
});
